(function () {
  function createCustomSplideArrows() {
    const arrows = document.createElement("div");
    arrows.classList.add("splide__arrows");

    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.className = "splide__arrow splide__arrow--prev";
    prevBtn.setAttribute("aria-label", "Previous");
    prevBtn.innerHTML = `
      <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M14.5 5.5 L8.5 12 L14.5 18.5"
              fill="none" stroke="currentColor" stroke-width="1"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "splide__arrow splide__arrow--next";
    nextBtn.setAttribute("aria-label", "Next");
    nextBtn.innerHTML = `
      <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M9.5 5.5 L15.5 12 L9.5 18.5"
              fill="none" stroke="currentColor" stroke-width="1"
              stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    arrows.appendChild(prevBtn);
    arrows.appendChild(nextBtn);
    return arrows;
  }

  function getNumberAttr(el, name, fallback = 0) {
    const v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }
  const px = (v) => `${v}px`;

  function initCarousels() {
    document.querySelectorAll('.js-home-products-carousel').forEach(function (carousel) {
      if (carousel.splideInstance) {
        carousel.splideInstance.destroy();
        carousel.classList.remove('is-initialized');
      }

      const largeDesktop = getNumberAttr(carousel, 'data-large-desktop-products-per-row', 1);
      const desktop      = getNumberAttr(carousel, 'data-desktop-products-per-row', 1);
      const laptop       = getNumberAttr(carousel, 'data-laptop-products-per-row', 1);
      const tablet       = getNumberAttr(carousel, 'data-tablet-products-per-row', 1);
      const mobile       = getNumberAttr(carousel, 'data-mobile-products-per-row', 1);

      const spaceLgHalf  = getNumberAttr(carousel, 'data-large-desktop-products-space', 0);
      const spaceDHalf   = getNumberAttr(carousel, 'data-desktop-products-space', 0);
      const spaceLapHalf = getNumberAttr(carousel, 'data-laptop-products-space', 0);
      const spaceTabHalf = getNumberAttr(carousel, 'data-tablet-products-space', 0);
      const spaceMobHalf = getNumberAttr(carousel, 'data-mobile-products-space', 0);

      const gapLg   = spaceLgHalf  * 2;
      const gapD    = spaceDHalf   * 2;
      const gapLap  = spaceLapHalf * 2;
      const gapTab  = spaceTabHalf * 2;
      const gapMob  = spaceMobHalf * 2;

      if (!carousel.querySelector('.splide__arrows')) {
        carousel.appendChild(createCustomSplideArrows());
      }

      const splide = new Splide(carousel, {
        type: 'slide',
        perPage: largeDesktop,
        perMove: 1,
        arrows: true,
        pagination: true,
        rewind: false,
        gap: px(gapLg),
        breakpoints: {
          1798: { perPage: desktop, gap: px(gapD) },
          1499: { perPage: laptop,  gap: px(gapLap) },
          991:  { perPage: tablet,  gap: px(gapTab) },
          767:  { perPage: mobile,  gap: px(gapMob) },
        },
      });

      splide.mount();
      carousel.splideInstance = splide;
      carousel.classList.add('is-initialized');
    });
  }

  document.addEventListener('DOMContentLoaded', initCarousels);

  if (window.Shopify && Shopify.designMode) {
    ['shopify:section:load','shopify:section:select','shopify:block:select','shopify:block:deselect']
      .forEach(ev => {
        document.addEventListener(ev, () => {
          initCarousels();
        });
      });
  }
})();